var resolveImports = function (start, files) {
  return wrap(start.content, [start.shortName], files);
};
var wrap = function (source, presentlyImported, files) {
  var importAllPattern = /^import \./;
  var importSomePattern = /^from \.\w+ import/;
  var sourceLines = source.split("\n");
  var lines = sourceLines.map(function (line, num) {
    if (line.match(importAllPattern)) {
      return replaceImportAll(parseImportAll(line), presentlyImported, files);
    }
    if (line.match(importSomePattern)) {
      return replaceImportSome(parseImportSome(line), num, presentlyImported, files);
    }
    return line;
  });
  return lines.join("\n");
};
var replaceImportAll = function (im, presentlyImported, files) {
  var sourceShortName = im.pkg + ".py";
  if (presentlyImported.includes(sourceShortName)) {
    var errMsg = sourceShortName + " has already been imported. Mutually recursive imports are not allowed.";
    throw errMsg;
  }
  var source = getContentByShortName(sourceShortName, files);
  var wrapped = wrap(source, presentlyImported.concat([sourceShortName]), files);
  return "\n" + wrapped + "\n";
};
var replaceImportSome = function (im, lineNumber, presentlyImported, files) {
  var sourceShortName = im.pkg + ".py";
  if (presentlyImported.includes(sourceShortName)) {
    var errMsg = sourceShortName + " has already been imported. Mutually recursive imports are not allowed.";
    throw errMsg;
  }
  var source = getContentByShortName(sourceShortName, files);
  var wrapped = wrap(source, presentlyImported.concat([sourceShortName]), files);
  var sourceLines = wrapped.split("\n").map(function (line) {
    return "\t" + line;
  });
  var names = im.names.join(", ");
  var functionName = "__wrap" + lineNumber;
  var head = "def " + functionName + "():\n";
  var body = sourceLines.join("\n") + "\n";
  var ret = "\treturn " + names + "\n";
  var tail = names + " = " + functionName + "()";
  return head + body + ret + tail;
};
var parseImportAll = function (line) {
  var pkg;
  var importMatches = line.match(/^import \.(\w+)[ \t]*$/);
  if (importMatches) {
    pkg = importMatches[1];
    return {
      pkg: pkg
    };
  }
  throw "Malformed import statement";
};
var parseImportSome = function (line) {
  var pkg;
  var names;
  var importMatches = line.match(/^from \.(\w+) import ([\w,\s]+)/);
  if (importMatches) {
    pkg = importMatches[1];
    names = importMatches[2].split(",").map(function (s) {
      return s.trim();
    });
    return {
      pkg: pkg,
      names: names
    };
  }
  throw "Malformed import statement: " + line;
};
var getContentByShortName = function (name, fileSet) {
  console.log(name);
  console.log(fileSet);
  return fileSet.filter(function (_a) {
    var shortName = _a.shortName;
    return shortName === name;
  })[0].content;
};
export { resolveImports };